import { IBuyerAssetGroupItem, IBuyerAssetGroupItemLocalized } from '../types';

/**
 * Formats the buyer asset groups list from raw data to localized format.
 */
export function formatBuyerAssetGroupsList(
  assetsData: IBuyerAssetGroupItem[]
): IBuyerAssetGroupItemLocalized[] {
  return (
    assetsData?.map(
      ({
        _id,
        categoryId,
        name,
        name_ar: nameAr,
        name_es: nameEs,
        name_he: nameHe,
        name_nl: nameNl,
      }) => ({
        id: _id,
        categoryId,
        label: {
          ar: nameAr,
          en: name,
          es: nameEs,
          he: nameHe,
          nl: nameNl,
        },
        labelStr: name,
        value: _id,
        checked: false,
      })
    ) || []
  );
}
